export default __webpack_public_path__ + "static/media/dog-paw.d6a69466.svg";